export const CHEQUE_ENTRY_LIST = "CHEQUE_ENTRY_LIST";
export const CHEQUE_STATUS_MASTER = "CHEQUE_STATUS_MASTER";

